export const COOKBOOKS = [
  {
    id: "cook-001",
    slug: "voice-agent-quickstart",
    title: "Voice Agent Quickstart",
    description:
      "Get a production-ready voice agent answering phone calls in under 30 minutes. Covers Twilio provisioning, the Pipecat pipeline, OpenAI Realtime, function calling, and deployment.",
    category: "Voice AI",
    difficulty: "Beginner",
    tags: ["Voice Agent", "Pipecat", "OpenAI Realtime", "Twilio"],
    steps: [
      "Provision a Twilio number",
      "Set up the Python environment",
      "Write the Pipecat agent",
      "Run locally with ngrok",
      "Add a function call",
      "Deploy to Render",
    ],
    image_url: "/images/cookbooks/cook-voice.svg",
    read_time: 30,
    status: "published",
    expected_at: "2026-03-05T10:00:00+00:00",
    references: [],
  },
  {
    id: "cook-002",
    slug: "chat-agent-persistent-memory",
    title: "Chat Agent with Persistent Memory",
    description:
      "Build a production chat agent with three layer memory backed by Supabase pgvector. Modular project layout, retries with backoff, idempotent writes, structured logging, a privacy boundary, and an eval harness.",
    category: "Chat AI",
    difficulty: "Intermediate",
    tags: ["LangGraph", "OpenAI", "pgvector", "Production"],
    steps: [
      "Project layout",
      "Install dependencies",
      "Settings",
      "Supabase client and schema",
      "Embeddings with retries",
      "The memory layer",
      "The LangGraph agent",
      "Entry point",
      "Tests",
      "The eval harness",
    ],
    image_url: "/images/cookbooks/cook-chat-memory.svg",
    read_time: 60,
    status: "published",
    expected_at: "2026-04-02T10:00:00+00:00",
    references: [],
  },
  {
    id: "cook-003",
    slug: "multi-agent-agentos-workflow",
    title: "Multi-Agent Workflow with AgentOS",
    description:
      "A four-agent research system at production grade. Pydantic schemas for handoffs, per-agent retry policies, circuit breakers, cost tracking, OpenTelemetry-compatible tracing, and an end-to-end eval harness.",
    category: "Agentic Systems",
    difficulty: "Intermediate",
    tags: ["LangGraph", "OpenAI", "Multi-Agent", "Production"],
    steps: [
      "Project layout",
      "Install dependencies",
      "Settings",
      "Schemas (handoff contracts)",
      "Telemetry",
      "Resilience (retries and circuit breakers)",
      "The workers",
      "Supervisor and judge",
      "Entry point",
      "Tests",
      "End-to-end eval",
    ],
    image_url: "/images/cookbooks/cook-multiagent.svg",
    read_time: 120,
    status: "published",
    expected_at: "2026-04-23T10:00:00+00:00",
    references: [],
  },
  {
    id: "cook-004",
    slug: "rag-system-from-scratch",
    title: "RAG System From Scratch",
    description:
      "A production RAG pipeline end to end: resumable batched ingestion, hybrid search with reciprocal rank fusion, cross-encoder reranking, citation-grounded streaming generation, an LRU cache, and RAGAS thresholds in CI.",
    category: "AI Research",
    difficulty: "Intermediate",
    tags: ["RAG", "OpenAI", "pgvector", "RAGAS"],
    steps: [
      "Project layout",
      "Install dependencies",
      "Settings",
      "Supabase schema",
      "Supabase client",
      "Chunking",
      "Batched embedding with retries",
      "Resumable ingestion",
      "Retrieval with hybrid search and RRF",
      "Streaming generation with citations",
      "Cache layer",
      "Tests",
      "RAGAS evaluation in CI",
    ],
    image_url: "/images/cookbooks/cook-rag.svg",
    read_time: 75,
    status: "published",
    expected_at: "2026-05-08T10:00:00+00:00",
    references: [],
  },
];
